KROWN.themeName = "Split";
KROWN.themeVersion = "4.2.0";

// Function to update the progress bar
function updateProgressBar(cartId, totalLimit, itemsInCart, packLimit) {
  var remainingItems = totalLimit - itemsInCart;
  var percentage = (itemsInCart / totalLimit) * 100;

  document.getElementById('remaining-items-' + cartId).innerText = remainingItems > 0 ? remainingItems : 0;
  document.getElementById('progress-bar-' + cartId).style.width = percentage + '%';
  document.getElementById('max-items-' + cartId).innerText = packLimit;
  // document.getElementById('progress-bar').innerText = itemsInCart >= totalLimit ? 'Free Shipping!' : '';
}

function gmOpenRewards() {
  document.querySelector('.ssw-reward-tab').click();
}

function gmOpenWishlist() {
  document.querySelector('#ssw-fave-side-button').click();
}

function gmOpenChangeLocation() {
  document.querySelector('.md-footer-selector__selector a').click();
}

// Utility function to set a cookie
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

// Function to get cookie by name
function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

const executeOnceOnDomContentLoaded = () => {
  // tab navigation

  let activeElement = document.activeElement;
  document.addEventListener("keyup", (e) => {
    if (e.keyCode == window.KEYCODES.TAB) {
      if (
        activeElement.classList.contains("focus") &&
        e.target != activeElement
      ) {
        activeElement.classList.remove("focus");
      }
      if (
        e.target.classList.contains("product-variant__input") ||
        e.target.classList.contains("button") ||
        e.target.classList.contains("product-item") ||
        e.target.classList.contains("spr-summary-actions-newreview") ||
        e.target.classList.contains("site-box-content-to-focus")
      ) {
        e.target.classList.add("focus");
      }
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if (window.location.pathname.includes("/challenge")) {
    setTimeout(() => {
      window.scroll({
        top: 0,
        behavior: "auto",
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll(".rte a img").forEach((elm) => {
    elm.parentNode.style.border = "none";
  });

  // Filter handle

  if (document.getElementById("site-filter-handle")) {
    document
      .getElementById("site-filter-handle")
      .addEventListener("click", (e) => {
        e.preventDefault();
        document.getElementById("site-filters").show();
        document
          .getElementById("site-filter-handle")
          .setAttribute("aria-expanded", "true");
      });
  }

  // fix quick add to cart

  setTimeout(() => {
    if (document.querySelector("modal-box quick-view-product")) {
      document.querySelector("modal-box quick-view-product").init();
    }
    if (document.querySelector("modal-box quick-add-to-cart")) {
      document.querySelector("modal-box quick-add-to-cart").init();
      document.querySelector("modal-box product-form").init();
    }
  }, 3050);

  // show newsletter popup confimation

  if (
    document.location.search == "?customer_posted=true" &&
    document.location.hash == "#newsletter-popup" &&
    document.getElementById("modal-popup")
  ) {
    const newsletterPopup = document.getElementById("modal-popup");
    newsletterPopup.show();
    localStorage.setItem(
      newsletterPopup._modalKey,
      JSON.stringify({
        shown: new Date().getTime(),
        content: newsletterPopup._modalText,
      })
    );
    setTimeout(() => {
      newsletterPopup.querySelectorAll("[data-js-close]").forEach((elm) =>
        elm.addEventListener("click", () => {
          newsletterPopup.hide(true);
        })
      );
    }, 100);
    clearTimeout(newsletterPopup._modalTimeout);
  }

  // custom cart listener

  if (document.querySelector("cart-form")) {
    document.querySelector("cart-form").addEventListener("cart-updated", () => {
      if (document.body.classList.contains("template-cart")) {
        if (document.querySelector("#AjaxCartForm .subtitle")) {
          document.querySelector(
            "#section-cart .box__heading .subtitle"
          ).innerHTML = document.querySelector(
            "#AjaxCartForm .subtitle"
          ).innerHTML;
        }
        if (
          document
            .getElementById("AjaxCartSubtotal")
            .querySelector("[data-cart-empty]")
        ) {
          document.querySelector(
            "#section-cart .box__heading .subtitle"
          ).innerHTML = "";
          if (
            !document
              .getElementById("AjaxCartSubtotal")
              .querySelector(".main-cart-empty-content")
          ) {
            document
              .getElementById("AjaxCartSubtotal")
              .append(
                document
                  .getElementById("section-cart")
                  .querySelector("template")
                  .content.cloneNode(true)
              );
          } else {
            document
              .getElementById("AjaxCartSubtotal")
              .querySelector(".main-cart-empty-content").style.display =
              "block";
          }
        } else if (
          document
            .getElementById("AjaxCartSubtotal")
            .querySelector(".main-cart-empty-content")
        ) {
          document
            .getElementById("AjaxCartSubtotal")
            .querySelector(".main-cart-empty-content").style.display = "none";
        }
      }

      if (
        document.querySelector("cart-recommendations") &&
        parseInt(document.querySelector("[data-cart-count]").textContent) == 0
      ) {
        document.querySelector("cart-recommendations").innerHTML = "";
      }
    });
  }

  // recommended products listener

  if (document.querySelector("#main-product-recommendations")) {
    document
      .querySelector("#main-product-recommendations")
      .addEventListener("product-recommendations-loaded", () => {
        eval(
          document.querySelector("#main-product-recommendations .js-fix-height")
            .textContent
        );
      });
  }

  // countdown

  const second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 24;

  const countdowns = document.querySelectorAll(
    ".product-item-countdown-container"
  );

  countdowns.forEach((countdownContainer) => {
    countdownEndDate = countdownContainer.attributes["data-countdown"].value;

    //console.log(countdownEndDate);

    const countDown = new Date(countdownEndDate).getTime(),
      x = setInterval(function () {
        const zeroPad = (num, places) => String(num).padStart(places, "0");

        const now = new Date().getTime(),
          distance = countDown - now,
          daysToGo = Math.floor(distance / day),
          hoursToGo = Math.floor((distance % day) / hour),
          minutesToGo = Math.floor((distance % hour) / minute),
          secondsToGo = Math.floor((distance % minute) / second);

        countdownContainer.querySelector(
          ".product-item-countdown-countdown"
        ).innerText =
          daysToGo +
          "D " +
          zeroPad(hoursToGo, 2) +
          ":" +
          zeroPad(minutesToGo, 2) +
          ":" +
          zeroPad(secondsToGo, 2);

        // countdownContainer.querySelector(".product-item-countdown-days").innerText = Math.floor(distance / (day)),
        //   countdownContainer.querySelector(".product-item-countdown-hours").innerText = Math.floor((distance % (day)) / (hour)),
        //   countdownContainer.querySelector(".product-item-countdown-minutes").innerText = Math.floor((distance % (hour)) / (minute)),
        //   countdownContainer.querySelector(".product-item-countdown-seconds").innerText = Math.floor((distance % (minute)) / second);

        //do something later when date is reached
        if (distance < 0) {
          // document.getElementById("headline").innerText = "It's my birthday!";
          // document.getElementById("countdown").style.display = "none";
          // document.getElementById("content").style.display = "block";
          clearInterval(x);
        }
        //seconds
      }, 0);
  });

  function flicker() {
    const element = document.querySelector("#xp-increase-fx-flicker");
    if (element) {
      document.querySelector("#xp-increase-fx-flicker").style.opacity = 1;
      document
        .querySelector("#xp-increase-fx-flicker")
        .animate({ opacity: Math.random() }, 100, flicker);
    }
  }
  flicker();

  const xpElement = document.querySelector("#xp-increase-fx");
  if (xpElement) {
    document.querySelector("#xp-increase-fx").style.display = "inline-block";
    document.querySelector("#xp-bar-fill").style.boxShadow =
      "-5px 0px 10px #fff inset";

    setTimeout(function () {
      document.querySelector("#xp-bar-fill").style.webkitTransition =
        "all 2s ease";
      document.querySelector("#xp-bar-fill").style.width =
        (document
          .querySelector("#xp-bar")
          .getAttribute("data-current-tier-points-points") /
          document.querySelector("#xp-bar").getAttribute("data-max-points")) *
          100 +
        "%";
    }, 100);

    setTimeout(function () {
      //document.querySelector("#xp-increase-fx").fadeOut(500);
      document.querySelector("#xp-bar-fill").style.webkitTransition =
        "all 0.5s ease";
      document.querySelector("#xp-bar-fill").style.boxShadow = "";
    }, 2000);
  }

  // setTimeout(function() {
  //   document.querySelector("#xp-bar-fill").style.width = "0.1%";
  // },3000);

  // The footer country selector is rendered by the Orbe geolocation app.
  // Older app versions rendered an <a>, current versions render a <button>
  // (.md-footer-selector__selector) whose visible label sits in the span
  // that is not .md-visuallyHidden. Support both and bail out if the app
  // embed is missing so the rest of this handler still runs.
  const footerCountrySelector = document.querySelector(
    '.md-footer-selector__container a, .md-footer-selector__container .md-footer-selector__selector'
  );
  const countryLabel = footerCountrySelector
    ? (
        footerCountrySelector.querySelector('span:not(.md-visuallyHidden)') ||
        footerCountrySelector
      ).textContent.trim()
    : '';

  const headerLocationChooser = document.querySelector('.header-location-chooser');
  if (headerLocationChooser && countryLabel) {
    headerLocationChooser.innerHTML =
      '<i class="gm-icon ri-global-line"></i>' + countryLabel;
  }

  // Mobile bottom-bar "Change my location" label. The Globo Mega Menu app
  // builds the bottom bar client-side after DOMContentLoaded, so poll
  // briefly until it appears. Globo menu 52930 still stores a legacy
  // customize_js one-liner that targets the same element, but it runs at
  // HTML parse time (before the element or the Orbe selector exist) and
  // always throws, and Globo's current admin UI no longer exposes the
  // field to edit it - the theme owns this label now.
  if (countryLabel) {
    let mobileLabelAttempts = 0;
    const setMobileLocationLabel = () => {
      const mobileLabel = document.querySelector('.change-my-location-mobile .gm-bb-text');
      if (mobileLabel) {
        mobileLabel.textContent = 'Change my location (' + countryLabel + ')';
      } else if (mobileLabelAttempts++ < 20) {
        setTimeout(setMobileLocationLabel, 500);
      }
    };
    setMobileLocationLabel();
  }

  const checkoutButton = document.querySelector('button[name="checkout"]');
  if (checkoutButton) {
    checkoutButton.addEventListener("click", (e) => {
      if (!document.querySelector('#agree:checked')) {
        e.preventDefault();
        return false;
      }
    });
  }

  const checkMyPointsButton = document.querySelector('#button-check-my-points');
  if (checkMyPointsButton) {
    checkMyPointsButton.addEventListener("click", (e) => {
      gmOpenRewards();
    });
  }
};

if (document.readyState !== "loading") {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener("DOMContentLoaded", executeOnceOnDomContentLoaded);
}

if (typeof SiteFilterHandle !== "function") {
  class SiteFilterHandle extends HTMLElement {
    constructor() {
      super();
      const sidebar = document.getElementById(
        this.getAttribute("aria-controls")
      );
      this.addEventListener("click", (e) => {
        if (!this.classList.contains("disable-sidebar")) {
          e.preventDefault();
          this.setAttribute("aria-expanded", "true");
          sidebar.show();
        }
      });
      this.addEventListener("keyup", (e) => {
        if (e.keyCode == window.KEYCODES.RETURN) {
          this.setAttribute("aria-expanded", "true");
          sidebar.show();
          sidebar.querySelector(".site-close-handle").focus();
        }
      });
    }
  }

  if (typeof customElements.get("site-filter-handle") == "undefined") {
    customElements.define("site-filter-handle", SiteFilterHandle);
  }

  // Method to check if an element is visible
  function isElementVisible(element) {
    return element.style.display !== "none";
  }

  // Toggle display function
  function toggleDisplay(selector) {
    const element = document.querySelector(selector);
    if (element) {
      if (isElementVisible(element)) {
        element.style.display = "none"; // Hide the element
      } else {
        element.style.display = "block"; // Show the element
      }
    }
  }

  const elementToggleWrapper = document.querySelector(
    ".account-points-history-toggle-wrapper"
  );
  const elementToggleCta = document.querySelector(
    "#account-points-history-toggle-cta"
  );
  const elementPointsHistory = document.querySelector(
    ".account-points-history"
  );

  if (elementToggleWrapper) {
    elementToggleCta.addEventListener("click", (e) => {
      e.preventDefault();
      toggleDisplay(".account-points-history");
      if (isElementVisible(elementPointsHistory)) {
        elementToggleCta.innerHTML = "Hide points history";
      } else {
        elementToggleCta.innerHTML = "Show points history";
      }
    });
  }

  // Function to execute when .dfd-root element is added
  function onDfdRootAdded() {
    const loadingElement = document.querySelector('.doofinder-loading');
      if (loadingElement) {
          loadingElement.style.display = 'none';
      }
  }
  
  // Function to check for the presence of .dfd-root element
  function checkForDfdRoot() {
      const dfdRootElement = document.querySelector('.dfd-results-grid');
      if (dfdRootElement) {
          onDfdRootAdded();
        if(pollingInterval !== undefined) {
          clearInterval(pollingInterval); // Stop polling once the element is found
        }
      }
  }

  if(document.querySelector('.doofinder-loading')) {
    // Set up a polling interval to check for the .dfd-root element every 500 milliseconds
    const pollingInterval = setInterval(checkForDfdRoot, 500);
  }
}
